import React from 'react';
import SearchInput from '../../components/SearchInput';

const ManageNFT = () => {
  return (
    <div className="">
      <div className="grid grid-cols-2 mb-4">
        <h4 className="mb-2">Stored NFT&apos;s</h4>
        <div className="flex justify-end items-center">
          <div className="inline-flex relative">
            <SearchInput
              name="commonSearch"
              id="commonSearch"
              placeholder="Search proejct"
            />
          </div>
        </div>
      </div>
      <div className="  w-full bg-brandGray px-8 py-4 rounded-xl">
        <div className="">
          <table className="table-auto md:table-fixed lg:table-auto w-full text-sm text-left  border-separate border-spacing-y-3 shadow-none">
            <tbody className="bg-[#F3F3F3] rounded-md ">
              <tr className="bg-white  border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td className="py-4 text-center">
                  <img
                    src="/img/nft-image.png"
                    alt=""
                    className="inline-block mx-auto"
                  />
                </td>
                <td
                  scope="row"
                  className=" py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Oslo Green Park
                  <p className="flex">
                    <img src="/img/iconlocation.svg" alt="" />
                    Netherlands
                  </p>
                </td>

                <td className="py-4 font-semibold">
                  Available NFTs
                  <p> 500</p>
                </td>
                <td className="padding-flexbox-around">
                  <span className="padding-curser-text">
                    Add back to Project
                  </span>
                </td>
              </tr>

              <tr className="bg-white  border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td className="py-4 text-center">
                  <img
                    src="/img/nft-image.png"
                    alt=""
                    className="inline-block mx-auto"
                  />
                </td>
                <td
                  scope="row"
                  className=" py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Oslo Green Park
                  <p className="flex">
                    <img src="/img/iconlocation.svg" alt="" />
                    Netherlands
                  </p>
                </td>

                <td className="py-4 font-semibold">
                  Available NFTs
                  <p> 500</p>
                </td>
                <td className="padding-flexbox-around">
                  <span className="padding-curser-text">
                    Add back to Project
                  </span>
                </td>
              </tr>

              <tr className="bg-white  border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td className="py-4 text-center">
                  <img
                    src="/img/nft-image.png"
                    alt=""
                    className="inline-block mx-auto"
                  />
                </td>
                <td
                  scope="row"
                  className=" py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Oslo Green Park
                  <p className="flex">
                    <img src="/img/iconlocation.svg" alt="" />
                    Netherlands
                  </p>
                </td>

                <td className="py-4 font-semibold">
                  Available NFTs
                  <p> 500</p>
                </td>
                <td className="padding-flexbox-around">
                  <span className="padding-curser-text">
                    Add back to Project
                  </span>
                </td>
              </tr>

              <tr className="bg-white  border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td className="py-4 text-center">
                  <img
                    alt=""
                    src="/img/nft-image.png"
                    className="inline-block mx-auto"
                  />
                </td>
                <td className=" py-4 font-semibold text-gray-900 dark:text-white">
                  Oslo Green Park
                  <p className="flex">
                    <img src="/img/iconlocation.svg" alt="" />
                    Netherlands
                  </p>
                </td>

                <td className="py-4 font-semibold">
                  Available NFTs
                  <p> 500</p>
                </td>
                <td className="padding-flexbox-around">
                  <span className="padding-curser-text">
                    Add back to Project
                  </span>
                </td>
              </tr>

              <tr className="bg-white  border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td className="py-4 text-center">
                  <img
                    src="/img/nft-image.png"
                    alt=""
                    className="inline-block mx-auto"
                  />
                </td>
                <td
                  scope="row"
                  className=" py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Oslo Green Park
                  <p className="flex">
                    <img src="/img/iconlocation.svg" alt="" />
                    Netherlands
                  </p>
                </td>

                <td className="py-4 font-semibold">
                  Available NFTs
                  <p> 500</p>
                </td>
                <td className="padding-flexbox-around">
                  <span className="padding-curser-text">
                    Add back to Project
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ManageNFT;
